/**
 * User location.
 *
 * The implementation lives in `@/providers/location-provider` so that one
 * acquisition is shared across every screen; this module stays as the import path
 * consumers already use.
 *
 * @module hooks/use-user-location
 */

export { useLocationControl, useUserLocation } from '@/providers/location-provider';
export type { LocationStatus, UserLocation } from '@/providers/location-provider';
